import type { RegisterOptions } from "react-hook-form";
import { FieldStatus } from "../../../../../fields/src/processFields/ProcessField";
import { ControllerFormField } from "../Controller";
import {
  DatePicker as PrimitiveDatePicker,
  type DatePickerProps
} from "@certa/catalyst/components/DatePicker";

type DatePickerFormFieldProps = (Omit<
  DatePickerProps,
  "status" | "aria-label"
> & {
  name: string;
  rules?: Omit<
    RegisterOptions,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  defaultValue?: string;
}) &
  (
    | {
        label?: string;
        ariaLabel: string;
      }
    | { label: string; ariaLabel?: string }
  );

export const DatePickerFormField = (props: DatePickerFormFieldProps) => {
  const {
    label,
    name,
    ariaLabel,
    rules,
    required: isRequired,
    defaultValue,
    ...restProps
  } = props;

  return (
    <ControllerFormField
      label={label}
      name={name}
      rules={rules}
      required={isRequired}
      defaultValue={defaultValue}
      render={field => {
        return (
          <PrimitiveDatePicker
            {...restProps}
            required={isRequired}
            status={!!field.error ? FieldStatus.ERROR : undefined}
            aria-label={(ariaLabel || label) as string}
            {...field}
          />
        );
      }}
    />
  );
};
